import React, { useEffect, useState, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tag } from 'primereact/tag';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Sidebar } from 'primereact/sidebar';
import { Card } from 'primereact/card';
import { FloatLabel } from 'primereact/floatlabel';
import { Divider } from 'primereact/divider';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useConfirmDialog } from "../utils/ConfirmDialog/ConfirmDialogProvider";
import axiosInstance from "../utils/axiosInstance";


const AdminPage = () => {
    const toast = useRef(null);
    const userFilterOP = useRef(null);
    const paymentFilterOP = useRef(null);
    const { showDialog } = useConfirmDialog();

    // Mock data
    const [userData, setUserData] = useState([]);

    const [paymentRequests, setPaymentRequests] = useState([]);

    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [refreshing, setRefreshing] = useState(false);

    // Dialog states
    const [userDialogVisible, setUserDialogVisible] = useState(false);
    const [extendMembershipVisible, setExtendMembershipVisible] = useState(false);
    const [paymentApprovalVisible, setPaymentApprovalVisible] = useState(false);

    // Selected items
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedPaymentRequest, setSelectedPaymentRequest] = useState(null);

    // Filters - separate for each tab
    const [userGlobalFilter, setUserGlobalFilter] = useState('');
    const [paymentGlobalFilter, setPaymentGlobalFilter] = useState('');
    const [userFilterSidebarVisible, setUserFilterSidebarVisible] = useState(false);
    const [paymentFilterSidebarVisible, setPaymentFilterSidebarVisible] = useState(false);

    // User filters
    const [userFilters, setUserFilters] = useState({
        status: null,
        role: null,
        membershipExpiring: false // üyeliği sona erecek olanlar
    });

    // Payment filters
    const [paymentFilters, setPaymentFilters] = useState({
        isPaid: null,
        paymentType: null,
        status: null
    });

    const [membershipExtension, setMembershipExtension] = useState({
        userId: '',
        months: 1
    });

    const [stats, setStats] = useState({
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        pendingPayments: 0,
        completedPayments: 0,
        totalRevenue: 0
    });

    useEffect(() => {
        getAllUsers();
        getAllPaymentRequests();
    }, []);

    useEffect(() => {
        calculateStats();
    }, [userData, paymentRequests]);

    const calculateStats = () => {
        const activeUsers = userData.filter(u => u.status?.id === 3);
        const inactiveUsers = userData.filter(u => u.status?.id !== 3);
        const pendingPayments = paymentRequests.filter(p => p.isPaid?.id === 0);
        const completedPayments = paymentRequests.filter(p => p.isPaid?.id === 1);
        const totalRevenue = completedPayments.reduce((sum, p) => sum + (p.paymentAmount || 0), 0);

        setStats({
            totalUsers: userData.length,
            activeUsers: activeUsers.length,
            inactiveUsers: inactiveUsers.length,
            pendingPayments: pendingPayments.length,
            completedPayments: completedPayments.length,
            totalRevenue
        });
    };

    const getAllUsers = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/api/v1/users/get-all');
            setUserData(response.data);


        } catch (error) {
            showToast('error', 'Hata', 'Kullanıcılar yüklenirken hata oluştu');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const getAllPaymentRequests = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/api/v1/users-payment-request/get-all');
            setPaymentRequests(response.data);
        } catch (error) {
            showToast('error', 'Hata', 'Ödeme talepleri yüklenirken hata oluştu');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const refreshData = async () => {
        setRefreshing(true);
        setLoading(true)
        try {
            await getAllUsers()
            await getAllPaymentRequests();
            showToast('success', 'Başarılı', 'Veriler güncellendi');
        } catch (error) {
            showToast('error', 'Hata', 'Veriler güncellenirken hata oluştu');
        } finally {
            setRefreshing(false);
            setLoading(false)
        }
    };

    const toggleUserStatus = (userId, currentStatus) => {
        const newStatusId = currentStatus.id === 3 ? 2 : 3;
        const newStatusValue = newStatusId === 3 ? "Aktif" : "Pasif";
        try {
            setLoading(true);
            //userUpdate api
            showToast('success', 'Başarılı', `Kullanıcı statüsü başarılı bir şekilde güncellendi .`);
            refreshData()
        }
        catch (error) {
            showToast('error', 'Hata', 'Kullanıcı statüsü güncellenirken hata oluştu');
        }
        finally {
            setLoading(false)
        }

    };

    const extendUserMembership = (userId, months) => {
        try {
            setLoading(true);
            //userUpdate api
            refreshData()
            showToast('success', 'Başarılı', `Üyelik ${months} ay uzatıldı`);
            setExtendMembershipVisible(false);

        }
        catch (error) {
            showToast('error', 'Hata', 'Üyelik süresi güncellenirken hata oluştu');
        } finally {
            setLoading(false)
        }

    };

    const approvePaymentRequest = (requestId) => {
        try {
            setLoading(true);
            //approvePaymentRequest api
            showToast('success', 'Başarılı', 'Ödeme talebi onaylandı');
            setPaymentApprovalVisible(false);
            refreshData()
        }
        catch (error) {
            showToast('error', 'Hata', 'Ödeme talebi onaylanırken hata oluştu.');
        } finally {
            setLoading(false)
        }
    };

    const showToast = (severity, summary, detail) => {
        toast.current?.show({ severity, summary, detail, life: 3000 });
    };

    // User filtering
    const getFilteredUsers = () => {
        return userData.filter(user => {
            // Status filter
            if (userFilters.status !== null && user.status?.id !== userFilters.status) return false;

            // Role filter  
            if (userFilters.role !== null && user.role !== userFilters.role) return false;

            // Membership expiring filter
            if (userFilters.membershipExpiring) {
                const endDate = new Date(user.membershipEndDate);
                const now = new Date();
                const daysLeft = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
                if (daysLeft > 30) return false;
            }

            // Global filter
            if (userGlobalFilter) {
                const searchTerm = userGlobalFilter.toLowerCase();
                return (
                    user.name?.toLowerCase().includes(searchTerm) ||
                    user.surname?.toLowerCase().includes(searchTerm) ||
                    user.username?.toLowerCase().includes(searchTerm) ||
                    user.email?.toLowerCase().includes(searchTerm) ||
                    user.identityNumber?.includes(searchTerm) ||
                    user.phoneNumber1?.includes(searchTerm)
                );
            }
            return true;
        });
    };

    // Payment filtering
    const getFilteredPayments = () => {
        return paymentRequests.filter(payment => {
            // Payment status filter
            if (paymentFilters.isPaid !== null && payment.isPaid?.id !== paymentFilters.isPaid) return false;

            // Payment type filter
            if (paymentFilters.paymentType !== null && payment.paymentType?.id !== paymentFilters.paymentType) return false;

            // Status filter
            if (paymentFilters.status !== null && payment.status?.id !== paymentFilters.status) return false;

            // Global filter
            if (paymentGlobalFilter) {
                const searchTerm = paymentGlobalFilter.toLowerCase();
                return (
                    payment.name?.toLowerCase().includes(searchTerm) ||
                    payment.identity?.includes(searchTerm) ||
                    payment.phoneNumber?.includes(searchTerm)
                );
            }
            return true;
        });
    };

    // Template functions
    const userStatusTemplate = (rowData) => {
        const isActive = rowData.status?.id === 3;
        return (
            <Tag
                value={rowData.status?.value || 'Bilinmiyor'}
                severity={isActive ? 'success' : 'danger'}
                className="text-xs sm:text-sm"
                icon={isActive ? 'pi pi-check' : 'pi pi-times'}
            />
        );
    };

    const userRoleTemplate = (rowData) => {
        const isAdmin = rowData.role === 'ROLE_ADMIN';
        return (
            <Tag
                value={isAdmin ? 'Admin' : 'Kullanıcı'}
                severity={isAdmin ? 'info' : 'secondary'}
                className="text-xs"
                icon={isAdmin ? 'pi pi-shield' : 'pi pi-user'}
            />
        );
    };

    const userActionsTemplate = (rowData) => {
        const isActive = rowData.status?.id === 3;

        return (
            <div className="flex gap-1">
                <Button
                    icon={isActive ? "pi pi-times" : "pi pi-check"}
                    className={`p-button-sm ${isActive ? 'p-button-danger' : 'p-button-success'} text-xs`}
                    tooltip={isActive ? "Pasif Yap" : "Aktif Yap"}
                    onClick={() => showDialog({
                        message: `Kullanıcıyı ${isActive ? 'pasif' : 'aktif'} etmek istediğinize emin misiniz ?`,
                        onConfirm: () => toggleUserStatus(rowData.id, rowData.status)
                    })}
                />
                <Button
                    icon="pi pi-calendar-plus"
                    className="p-button-sm p-button-outlined text-xs"
                    tooltip="Süre Uzat"
                    onClick={() => {
                        setSelectedUser(rowData);
                        setMembershipExtension({ userId: rowData.id, months: 1 });
                        setExtendMembershipVisible(true);
                    }}
                />
                <Button
                    icon="pi pi-eye"
                    className="p-button-sm p-button-outlined text-xs"
                    tooltip="Detayları Görüntüle"
                    onClick={() => {
                        setSelectedUser(rowData);
                        setUserDialogVisible(true);
                    }}
                />
            </div>
        );
    };

    const paymentStatusTemplate = (rowData) => {
        const isPaid = rowData.isPaid?.id === 1;
        return (
            <div className="flex justify-center items-center">
                <Tag
                    value={isPaid ? 'Ödendi' : 'Bekliyor'}
                    severity={isPaid ? 'success' : 'warning'}
                    className="text-xs sm:text-sm rounded-xl"
                    icon={isPaid ? 'pi pi-check' : 'pi pi-clock'}
                />
            </div>

        );
    };

    const paymentActionsTemplate = (rowData) => {
        const isPaid = rowData.isPaid?.id === 1;

        return (<div className="flex justify-center items-center">{isPaid ?
            <Tag icon="pi pi-check" value="Onaylandı" severity="success" className="text-xs rounded-xl" />
            :
            <Button
                label="Onayla"
                icon="pi pi-check"
                className="rounded-xl shadow-lg cursor-pointer text-white bg-green-700 dark:bg-green-800 hover:bg-green-800 dark:hover:bg-green-700 px-2 py-1"
                onClick={() => {
                    setSelectedPaymentRequest(rowData);
                    setPaymentApprovalVisible(true);
                }}
            />
        }
        </div>)

    }
    const membershipEndTemplate = (rowData) => {
        if (!rowData.membershipEndDate) return '-';

        const endDate = new Date(rowData.membershipEndDate);
        const now = new Date();
        const daysLeft = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

        const severity = daysLeft <= 7 ? 'danger' : daysLeft <= 30 ? 'warning' : 'success';

        return (
            <div className="text-center">
                <div className="text-xs sm:text-sm">{endDate.toLocaleDateString('tr-TR')}</div>
                <Tag value={`${daysLeft} gün`} severity={severity} className="text-xs mt-1" />
            </div>
        );
    };

    const amountTemplate = (rowData) => {
        return (
            <div className="text-right font-semibold text-xs sm:text-sm">
                {new Intl.NumberFormat('tr-TR', {
                    style: 'currency',
                    currency: 'TRY'
                }).format(rowData.paymentAmount || 0)}
            </div>
        );
    };

    const avatarTemplate = (rowData) => {
        return (
            <div className="flex items-center gap-2">
                <Avatar
                    label={`${rowData.name?.[0] || ''}${rowData.surname?.[0] || ''}`}
                    className="mr-2"
                    size="normal"
                    style={{ backgroundColor: '#9c88ff', color: '#ffffff' }}
                />
                <div>
                    <div className="font-semibold text-sm">{rowData.name} {rowData.surname}</div>
                    <div className="text-xs text-gray-500 dark:text-gray-400">{rowData.username}</div>
                </div>
            </div>
        );
    };

    const dateTemplate = (rowData, field) => {
        const date = new Date(rowData[field]);
        return <span className="text-xs sm:text-sm">{date.toLocaleDateString('tr-TR')}</span>;
    };

    // Headers
    const usersHeader = (
        <div className="flex flex-col gap-2 sm:gap-4 p-1 sm:p-2">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
                <div className="flex items-center gap-2">
                    <h5 className="m-0 text-base sm:text-lg font-semibold text-gray-900 dark:text-white">Kullanıcılar</h5>
                </div>
                <div>
                    <span className="flex gap-2">
                        <i className="pi pi-search text-gray-400 dark:text-gray-300" />
                        <InputText
                            value={userGlobalFilter}
                            onChange={(e) => setUserGlobalFilter(e.target.value)}
                            placeholder="Kullanıcı ara"
                            className="text-xs sm:text-sm w-full bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white"
                        />
                    </span>
                </div>
                <div className="flex flex-row gap-1 sm:gap-2 flex-wrap items-center">
                    <Button
                        icon="pi pi-filter"
                        className="p-button-outlined text-xs sm:text-sm p-1 sm:p-2"
                        tooltip="Filtrele"
                        onClick={() => setUserFilterSidebarVisible(true)}
                    />

                    <Button
                        icon="pi pi-download"
                        className="p-button-outlined text-xs sm:text-sm p-1 sm:p-2"
                        tooltip="Dışa Aktar"
                        onClick={(e) => userFilterOP.current.toggle(e)}
                    />

                    <Button
                        icon="pi pi-refresh"
                        className={`p-button-outlined text-xs sm:text-sm p-1 sm:p-2 ${refreshing ? 'p-button-loading' : ''}`}
                        tooltip="Yenile"
                        onClick={refreshData}
                        disabled={refreshing}
                    />
                </div>
            </div>


        </div>
    );

    const paymentsHeader = (
        <div className="flex flex-col gap-2 sm:gap-4 p-1 sm:p-2">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
                <div className="flex items-center gap-2">
                    <h5 className="m-0 text-base sm:text-lg font-semibold text-gray-900 dark:text-white">Ödeme Talepleri</h5>
                </div>
                <div>
                    <span className="flex gap-2">
                        <i className="pi pi-search text-gray-400 dark:text-gray-300" />
                        <InputText
                            value={paymentGlobalFilter}
                            onChange={(e) => setPaymentGlobalFilter(e.target.value)}
                            placeholder="Ödeme ara"
                            className="text-xs sm:text-sm w-full bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white"
                        />
                    </span>
                </div>
                <div className="flex flex-row gap-1 sm:gap-2 flex-wrap">
                    <Button
                        icon="pi pi-filter"
                        className="p-button-outlined text-xs sm:text-sm p-1 sm:p-2"
                        tooltip="Filtrele"
                        onClick={() => setPaymentFilterSidebarVisible(true)}
                    />

                    <Button
                        icon="pi pi-download"
                        className="p-button-outlined text-xs sm:text-sm p-1 sm:p-2"
                        tooltip="Dışa Aktar"
                        onClick={(e) => paymentFilterOP.current.toggle(e)}
                    />
                </div>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <style jsx>{`
    /* TabView Styling - Light Mode */
    .p-tabview .p-tabview-nav {
        background: #f8f9fa;
        border-color: #dee2e6;
        border-width: 0 0 2px 0;
        padding: 0;
    }
    .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        background: #f0f0f0;
        color: #495057;
        border: 1px solid #dee2e6;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        margin-right: 2px;
        font-size: 0.875rem;
        padding: 0.5rem 1rem;
        transition: background-color 0.2s;
    }
    .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
        background: #ffffff;
        color: #3b82f6;
        border-color: #3b82f6 #dee2e6 transparent #dee2e6;
        border-top-width: 3px;
    }
    .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
        background: #e9ecef;
        color: #495057;
    }
    
    /* TabView Styling - Dark Mode */
    .dark .p-tabview .p-tabview-nav {
        background: #1f2937;
        border-color: #374151;
        border-width: 0 0 2px 0;
    }
    .dark .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        background: #1e293b;
        color: #94a3b8;
        border: 1px solid #374151;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
    }
    .dark .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
        background: #2d3748;
        color: #ffffff;
        border-color: #4f46e5 #374151 transparent #374151;
        border-top-width: 3px;
    }
    .dark .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
        background: #2d3748;
        color: #e5e7eb;
    }

    .dark .p-tabview .p-tabview-panels {
        padding: 0.5rem !important;
        background: #2d3748;
        color: #e5e7eb;
    }
    .p-tabview .p-tabview-panels {
        padding: 0.5rem !important;
    }
    
    /* Mobile padding adjustments */
    @media (max-width: 640px) {
        .p-card .p-card-body {
            padding: 0.5rem !important;
        }
        .p-card .p-card-content {
            padding: 0.5rem 0 !important;
        }
        .dark .p-tabview .p-tabview-panels {
            padding: 0.5rem !important;
            background: #2d3748;
            color: #e5e7eb;
        }
        .p-tabview .p-tabview-panels {
            padding: 0.5rem !important;
        }
        .p-tabview .p-tabview-nav li .p-tabview-nav-link {
            padding: 0.35rem 0.5rem;
            font-size: 0.75rem;
        }
        
        /* Other mobile optimizations */
        .p-dropdown {
            height: 2rem;
        }
        .p-dropdown .p-dropdown-label {
            padding: 0.25rem 0.5rem;
        }
        .p-calendar .p-inputtext {
            padding: 0.25rem 0.5rem;
            height: 2rem;
        }
        .p-button {
            padding: 0.25rem 0.5rem;
        }
        
        /* Card component spacing */
        .p-card h3 {
            margin-bottom: 0.5rem;
        }
        .p-card .grid {
            gap: 0.5rem !important;
        }
    }
    
    /* Dialog styling */
    .p-dialog-mask {
        backdrop-filter: blur(5px);
        background-color: rgba(0, 0, 0, 0.4) !important;
    }
    
    .p-dialog {
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3) !important;
    }

    /* DataTable responsive styling */
    @media (max-width: 768px) {
        .p-datatable-wrapper {
            overflow-x: auto;
        }
        .p-datatable .p-datatable-thead > tr > th {
            font-size: 0.75rem;
            padding: 0.5rem 0.25rem;
        }
        .p-datatable .p-datatable-tbody > tr > td {
            font-size: 0.75rem;
            padding: 0.5rem 0.25rem;
        }
    }

    /* Sidebar dark mode styling */
    .dark .p-sidebar {
        background: #1f2937;
        color: #e5e7eb;
    }
    
    .dark .p-sidebar .p-sidebar-header {
        background: #1f2937;
        color: #e5e7eb;
        border-bottom: 1px solid #374151;
    }

    /* OverlayPanel dark mode styling */
    .dark .p-overlaypanel {
        color: #e5e7eb;
        border: 1px solid #374151;
    }

    /* Confirm Dialog dark mode styling */
    .dark .p-confirmdialog {
        background: #1f2937;
        color: #e5e7eb;
        border: 1px solid #374151;
    }

    .dark .p-confirmdialog .p-confirmdialog-header {
        background: #1f2937;
        color: #e5e7eb;
        border-bottom: 1px solid #374151;
    }
`}</style>
            <div className="p-2 sm:p-4 lg:p-6">
                <Toast ref={toast} />
                <ConfirmDialog />

                {/* Header */}
                <div className="mb-4 sm:mb-6">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 dark:text-white">
                                Admin Paneli
                            </h1>
                            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 mt-1">
                                Kullanıcı ve ödeme yönetimi
                            </p>
                        </div>
                    </div>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 mb-4 sm:mb-6">
                    <Card className="text-center p-2 sm:p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-colors">
                        <div className="text-lg sm:text-2xl font-bold text-blue-600 dark:text-blue-400">
                            {stats.totalUsers}
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">Toplam Kullanıcı</div>
                    </Card>

                    <Card className="text-center p-2 sm:p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-colors">
                        <div className="text-lg sm:text-2xl font-bold text-green-600 dark:text-green-400">
                            {stats.activeUsers}
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">Aktif Kullanıcı</div>
                    </Card>

                    <Card className="text-center p-2 sm:p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-colors">
                        <div className="text-lg sm:text-2xl font-bold text-orange-600 dark:text-orange-400">
                            {stats.pendingPayments}
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">Bekleyen Ödeme</div>
                    </Card>

                    <Card className="text-center p-2 sm:p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-colors">
                        <div className="text-lg sm:text-2xl font-bold text-purple-600 dark:text-purple-400">
                            {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(stats.totalRevenue)}
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">Toplam Gelir</div>
                    </Card>
                </div>

                {/* Tabs */}
                <TabView
                    activeIndex={activeTab}
                    onTabChange={(e) => setActiveTab(e.index)}
                    className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm"
                >
                    {/* Users Tab */}
                    <TabPanel header="Kullanıcılar" leftIcon="pi pi-users">
                        <div className="bg-white dark:bg-gray-800 transition-colors">
                            <DataTable
                                value={getFilteredUsers()}
                                header={usersHeader}
                                loading={loading}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                className="custom-datatable"
                                responsiveLayout="stack"
                                breakpoint="768px"
                                emptyMessage="Kullanıcı bulunamadı"
                                stripedRows
                                dataKey="id"
                                sortMode="multiple"
                                removableSort
                            >
                                <Column field="name" header="Kullanıcı" body={avatarTemplate} sortable style={{ minWidth: '200px' }} />
                                <Column field="email" header="E-posta" sortable style={{ minWidth: '200px' }} />
                                <Column field="phoneNumber1" header="Telefon" sortable style={{ minWidth: '120px' }} />
                                <Column field="identityNumber" header="TC Kimlik" sortable style={{ minWidth: '130px' }} />
                                <Column field="role" header="Rol" body={userRoleTemplate} sortable style={{ minWidth: '100px' }} />
                                <Column field="status" header="Durum" body={userStatusTemplate} sortable style={{ minWidth: '100px' }} />
                                <Column field="membershipEndDate" header="Üyelik Bitiş" body={membershipEndTemplate} sortable style={{ minWidth: '150px' }} />
                                <Column field="dateOfRecorded" header="Kayıt Tarihi" body={(rowData) => dateTemplate(rowData, 'dateOfRecorded')} sortable style={{ minWidth: '120px' }} />
                                <Column field="countryOfBirth" header="Doğum Yeri" sortable style={{ minWidth: '120px' }} />
                                <Column field="companyName" header="Şirket" sortable style={{ minWidth: '150px' }} />
                                <Column header="İşlemler" body={userActionsTemplate} frozen alignFrozen="right" style={{ minWidth: '200px' }} />
                            </DataTable>
                        </div>
                    </TabPanel>

                    {/* Payments Tab */}
                    <TabPanel header="Ödeme Talepleri" leftIcon="pi pi-credit-card">
                        <div className="bg-white dark:bg-gray-800 transition-colors">
                            <DataTable
                                value={getFilteredPayments()}
                                header={paymentsHeader}
                                loading={loading}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                className="custom-datatable"
                                responsiveLayout="stack"
                                breakpoint="768px"
                                emptyMessage="Ödeme talebi bulunamadı"
                                stripedRows
                                sortMode="multiple"
                                removableSort
                            >
                                <Column field="name" header="Ad" className="font-medium" sortable style={{ minWidth: '120px' }} />
                                <Column field="identity" header="TC Kimlik" sortable style={{ minWidth: '130px' }} />
                                <Column field="phoneNumber" header="Telefon" sortable style={{ minWidth: '120px' }} />
                                <Column field="paymentType.value" header="Ödeme Türü" sortable style={{ minWidth: '120px' }} />
                                <Column field="paymentAmount" header="Tutar" body={amountTemplate} sortable style={{ minWidth: '120px' }} />
                                <Column field="planMonths" header="Plan" body={(rowData) => `${rowData.planMonths} Ay`} className="text-center" sortable style={{ minWidth: '80px' }} />
                                <Column field="dateOfRecorded" header="Kayıt Tarihi" body={(rowData) => dateTemplate(rowData, 'dateOfRecorded')} sortable style={{ minWidth: '120px' }} />
                                <Column field="userWhoRecorded" header="Kaydeden" sortable style={{ minWidth: '120px' }} />
                                <Column field="distanceSellingContract.value" header="Mesafeli Satış" sortable style={{ minWidth: '120px' }} />
                                <Column field="isPaid" header="Ödeme Durumu" body={paymentStatusTemplate} sortable style={{ minWidth: '120px' }} />
                                <Column header="İşlemler" body={paymentActionsTemplate} frozen alignFrozen="right" style={{ minWidth: '150px' }} />
                            </DataTable>
                        </div>
                    </TabPanel>
                </TabView>

                {/* User Detail Dialog */}
                <Dialog
                    header="Kullanıcı Detayları"
                    visible={userDialogVisible}
                    onHide={() => setUserDialogVisible(false)}
                    className="w-11/12 sm:w-3/4 lg:w-1/2"
                    modal
                >
                    {selectedUser && (
                        <div className="space-y-4 p-2 max-h-96 overflow-y-auto">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div><label className="block text-sm font-medium mb-1">Ad Soyad</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.name} {selectedUser.surname}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Kullanıcı Adı</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.username}</p></div>
                                <div><label className="block text-sm font-medium mb-1">E-posta</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.email}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Telefon 1</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.phoneNumber1}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Telefon 2</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.phoneNumber2}</p></div>
                                <div><label className="block text-sm font-medium mb-1">TC Kimlik</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.identityNumber}</p></div>
                                <div><label className="block text-sm font-medium mb-1">VKN</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.vkn}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Şirket</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.companyName}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Doğum Tarihi</label><p className="text-sm text-gray-600 dark:text-gray-300">{new Date(selectedUser.birthday).toLocaleDateString('tr-TR')}</p></div>
                                <div><label className="block text-sm font-medium mb-1">Doğum Yeri</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.countryOfBirth} / {selectedUser.districtOfBirth}</p></div>
                                <div className="sm:col-span-2"><label className="block text-sm font-medium mb-1">İkamet Adresi</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.countryOfResidentialAddress} / {selectedUser.districtOfResidentialAddress} - {selectedUser.detailOfResidentialAddress}</p></div>
                                <div className="sm:col-span-2"><label className="block text-sm font-medium mb-1">İş Adresi</label><p className="text-sm text-gray-600 dark:text-gray-300">{selectedUser.countryOfWorkAddress} / {selectedUser.districtOfWorkAddress} - {selectedUser.detailOfWorkAddress}</p></div>
                            </div>
                        </div>
                    )}
                </Dialog>

                {/* Membership Extension Dialog */}
                <Dialog
                    header="Üyelik Süresi Uzat"
                    visible={extendMembershipVisible}
                    onHide={() => setExtendMembershipVisible(false)}
                    className="w-11/12 sm:w-96"
                    modal
                >
                    <div className="space-y-4 p-2">
                        <div className="text-sm text-gray-600 mb-8">
                            <strong>{selectedUser?.name} {selectedUser?.surname}</strong> kullanıcısının üyelik süresini uzatın
                        </div>

                        <FloatLabel>
                            <Dropdown
                                id="months"
                                value={membershipExtension.months}
                                options={[
                                    { label: '1 Ay', value: 1 },
                                    { label: '3 Ay', value: 3 },
                                    { label: '6 Ay', value: 6 },
                                    { label: '12 Ay', value: 12 }
                                ]}
                                onChange={(e) => setMembershipExtension({ ...membershipExtension, months: e.value })}
                                className="w-full text-sm"
                            />
                            <label htmlFor="months">Uzatılacak Süre</label>
                        </FloatLabel>

                        <div className="flex justify-end gap-2 pt-4">
                            <Button
                                label="İptal"
                                className="rounded-xl shadow-lg cursor-pointer text-white bg-red-700 dark:bg-red-800 hover:bg-red-800 dark:hover:bg-red-700 px-2 py-1"
                                onClick={() => setExtendMembershipVisible(false)}
                            />
                            <Button
                                label="Uzat"
                                className="rounded-xl shadow-lg cursor-pointer text-white bg-green-700 dark:bg-green-800 hover:bg-green-800 dark:hover:bg-green-700 px-2 py-1"
                                onClick={() => extendUserMembership(membershipExtension.userId, membershipExtension.months)}
                            />
                        </div>
                    </div>
                </Dialog>

                {/* Payment Approval Dialog */}
                <Dialog
                    header="Ödeme Talebini Onayla"
                    visible={paymentApprovalVisible}
                    onHide={() => setPaymentApprovalVisible(false)}
                    className="w-11/12 sm:w-96"
                    modal
                >
                    <div className="space-y-4 py-2">
                        {selectedPaymentRequest && (
                            <div className="space-y-3">
                                <div className="border-b pb-3">
                                    <h4 className="font-semibold text-sm">Ödeme Detayları</h4>
                                    <div className="text-xs text-gray-600 dark:text-gray-300 space-y-2 mt-2">
                                        <div>Ad: {selectedPaymentRequest.name}</div>
                                        <div>TC: {selectedPaymentRequest.identity}</div>
                                        <div>Telefon: {selectedPaymentRequest.phoneNumber}</div>
                                        <div>Tutar: {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(selectedPaymentRequest.paymentAmount)}</div>
                                        <div>Plan: {selectedPaymentRequest.planMonths} Ay</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end gap-4">
                            <Button
                                label="İptal"
                                className="rounded-xl shadow-lg cursor-pointer text-white bg-red-700 dark:bg-red-800 hover:bg-red-800 dark:hover:bg-red-700 p-2"
                                onClick={() => setPaymentApprovalVisible(false)}
                            />
                            <Button
                                label="Onayla"
                                className="rounded-xl shadow-lg cursor-pointer text-white bg-green-700 dark:bg-green-800 hover:bg-green-800 dark:hover:bg-green-700 p-2"
                                onClick={() => approvePaymentRequest(selectedPaymentRequest?.id)}
                            />
                        </div>
                    </div>
                </Dialog>

                {/* User Filters Sidebar */}
                <Sidebar
                    visible={userFilterSidebarVisible}
                    onHide={() => setUserFilterSidebarVisible(false)}
                    position="right"
                    className="w-80"
                >
                    <h3 className="text-lg font-semibold mb-4">Kullanıcı Filtreleri</h3>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-2">Kullanıcı Durumu</label>
                            <Dropdown
                                value={userFilters.status}
                                options={[
                                    { label: 'Tümü', value: null },
                                    { label: 'Aktif', value: 3 },
                                    { label: 'Pasif', value: 2 }
                                ]}
                                onChange={(e) => setUserFilters({ ...userFilters, status: e.value })}
                                placeholder="Durum seçin"
                                className="w-full text-sm"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2">Rol</label>
                            <Dropdown
                                value={userFilters.role}
                                options={[
                                    { label: 'Tümü', value: null },
                                    { label: 'Admin', value: 'ROLE_ADMIN' },
                                    { label: 'Kullanıcı', value: 'ROLE_USER' }
                                ]}
                                onChange={(e) => setUserFilters({ ...userFilters, role: e.value })}
                                placeholder="Rol seçin"
                                className="w-full text-sm"
                            />
                        </div>

                        <div className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="membershipExpiring"
                                checked={userFilters.membershipExpiring}
                                onChange={(e) => setUserFilters({ ...userFilters, membershipExpiring: e.target.checked })}
                            />
                            <label htmlFor="membershipExpiring" className="text-sm">Üyeliği sona erecek olanlar (30 gün)</label>
                        </div>

                        <Divider />

                        <div className="flex gap-2 pt-4">
                            <Button
                                label="Temizle"
                                className="p-button-outlined text-sm flex-1"
                                onClick={() => setUserFilters({ status: null, role: null, membershipExpiring: false })}
                            />
                            <Button
                                label="Uygula"
                                className="p-button-success text-sm flex-1"
                                onClick={() => setUserFilterSidebarVisible(false)}
                            />
                        </div>
                    </div>
                </Sidebar>

                {/* Payment Filters Sidebar */}
                <Sidebar
                    visible={paymentFilterSidebarVisible}
                    onHide={() => setPaymentFilterSidebarVisible(false)}
                    position="right"
                    className="w-80"
                >
                    <h3 className="text-lg font-semibold mb-4">Ödeme Filtreleri</h3>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-2">Ödeme Durumu</label>
                            <Dropdown
                                value={paymentFilters.isPaid}
                                options={[
                                    { label: 'Tümü', value: null },
                                    { label: 'Bekleyen', value: 0 },
                                    { label: 'Ödendi', value: 1 }
                                ]}
                                onChange={(e) => setPaymentFilters({ ...paymentFilters, isPaid: e.value })}
                                placeholder="Ödeme durumu seçin"
                                className="w-full text-sm"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2">Ödeme Türü</label>
                            <Dropdown
                                value={paymentFilters.paymentType}
                                options={[
                                    { label: 'Tümü', value: null },
                                    { label: 'Havale / EFT', value: 1 },
                                    { label: 'Kredi Kartı', value: 2 }
                                ]}
                                onChange={(e) => setPaymentFilters({ ...paymentFilters, paymentType: e.value })}
                                placeholder="Ödeme türü seçin"
                                className="w-full text-sm"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2">Talep Durumu</label>
                            <Dropdown
                                value={paymentFilters.status}
                                options={[
                                    { label: 'Tümü', value: null },
                                    { label: 'Aktif', value: 3 },
                                    { label: 'Pasif', value: 2 }
                                ]}
                                onChange={(e) => setPaymentFilters({ ...paymentFilters, status: e.value })}
                                placeholder="Talep durumu seçin"
                                className="w-full text-sm"
                            />
                        </div>

                        <Divider />

                        <div className="flex gap-2 pt-4">
                            <Button
                                label="Temizle"
                                className="p-button-outlined text-sm flex-1"
                                onClick={() => setPaymentFilters({ isPaid: null, paymentType: null, status: null })}
                            />
                            <Button
                                label="Uygula"
                                className="p-button-success text-sm flex-1"
                                onClick={() => setPaymentFilterSidebarVisible(false)}
                            />
                        </div>
                    </div>
                </Sidebar>

                {/* Export Overlays */}
                <OverlayPanel ref={userFilterOP}>
                    <div className="space-y-2">
                        <Button label="CSV Export" icon="pi pi-file" className="p-button-outlined w-full text-sm" />
                        <Button label="Excel Export" icon="pi pi-file-excel" className="p-button-outlined w-full text-sm" />
                        <Button label="PDF Export" icon="pi pi-file-pdf" className="p-button-outlined w-full text-sm" />
                    </div>
                </OverlayPanel>

                <OverlayPanel ref={paymentFilterOP}>
                    <div className="space-y-2">
                        <Button label="CSV Export" icon="pi pi-file" className="p-button-outlined w-full text-sm" />
                        <Button label="Excel Export" icon="pi pi-file-excel" className="p-button-outlined w-full text-sm" />
                        <Button label="PDF Export" icon="pi pi-file-pdf" className="p-button-outlined w-full text-sm" />
                    </div>
                </OverlayPanel>
            </div>
        </div>
    );
};

export default AdminPage;